import React, { useCallback, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import Select, { components, GroupBase, SingleValueProps } from 'react-select'

import { Dashboard as DashboardIcon } from 'styles/design-system/svg/icons'

import { getSelectStyles } from '@app/utils'

type OptionType = {
  label: string
  value: string
}

const SingleValue = (props: SingleValueProps<OptionType, false, GroupBase<OptionType>>) => {
  return (
    <components.SingleValue {...props}>
      <div className="flex items-center  gap-3xs">
        <DashboardIcon />
        {props.children}
      </div>
    </components.SingleValue>
  )
}

type DashboardSelectProps = {
  options: OptionType[]
  pathname: string
}

export const DashboardSelect = ({ options, pathname }: DashboardSelectProps) => {
  const router = useRouter()

  useEffect(() => {
    options.forEach(({ value }) => {
      router.prefetch(value)
    })
  }, [router, options])

  const handleChange = useCallback(
    (option: OptionType) => {
      router.push(option.value)
    },
    [router],
  )

  return (
    <Select
      {...getSelectStyles()}
      components={{ SingleValue }}
      onChange={handleChange}
      options={options}
      defaultValue={options.find((o) => pathname === '/' ? o.value === '/dashboard/sales-activity' : o.value === pathname)}
      formatOptionLabel={({ label }) => {
        return <span>{label}</span>
      }}
    />
  )
}
